/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyRegistrationCheckLinkDto } from './CompanyRegistrationCheckLinkDto';
import type { CompanyRegistrationInvoiceDto } from './CompanyRegistrationInvoiceDto';
import type { InvoiceDto } from './InvoiceDto';
import type { ProductApprovalInvoiceDto } from './ProductApprovalInvoiceDto';
export type CompanyRegistrationCheckStepDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    companyId?: string;
    checkStepState?: CompanyRegistrationCheckStepDto.checkStepState;
    checkStepType?: CompanyRegistrationCheckStepDto.checkStepType;
    comment?: string;
    allClaimsAvailable?: boolean;
    checkLinks?: Array<CompanyRegistrationCheckLinkDto>;
    invoice?: (InvoiceDto | CompanyRegistrationInvoiceDto | ProductApprovalInvoiceDto);
};
export namespace CompanyRegistrationCheckStepDto {
    export enum checkStepState {
        NOT_AVAILABLE = 'NOT_AVAILABLE',
        IN_PROGRESS = 'IN_PROGRESS',
        REJECTED = 'REJECTED',
        ACCEPTED = 'ACCEPTED',
    }
    export enum checkStepType {
        PLAUSIBILITY_FLUID_FINDER = 'PLAUSIBILITY_FLUID_FINDER',
        CLAIM = 'CLAIM',
        INFO_LETTER = 'INFO_LETTER',
        INVOICE = 'INVOICE',
    }
}

